import { inject, Injectable } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { BehaviorSubject, catchError, map, of } from "rxjs";
import { SystemUserMessageResponse } from "../models/RequestQuote";
import { AuthService } from "../auth/auth.service";


@Injectable({
  providedIn: 'root'
})
export class MessageCenterService {
    private apiUrl = AppConfig.apiUrl;
authservice = inject(AuthService);       
    private token = this.authservice.getToken();    
    httpClient = inject(HttpClient);
    private systemUserMessages$ = new BehaviorSubject<boolean>(false);

    getSystemUserMessagesClearance(tempQuoteId: string){
      const path=`/api/TempQuoteMessages/GetSystemUserMessages?tempquoteid=${tempQuoteId}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<SystemUserMessageResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getSystemUserMessagesIndication(indicationId: string){
      const path=`/api/TempQuoteMessages/GetSystemUserMessages?indicationId=${indicationId}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<SystemUserMessageResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getSystemUserMessagesQuote(quoteId: string){
      const path=`/api/TempQuoteMessages/GetSystemUserMessages?quoteId=${quoteId}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<SystemUserMessageResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getSystemUserMessagesPolicy(policyId: string){
      const path=`/api/TempQuoteMessages/GetSystemUserMessages?policyId=${policyId}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<SystemUserMessageResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    newUserMessageClearance(userId: string, tempQuoteId: string, message: string){  
  const doubleEncodedMessage = encodeURIComponent(encodeURIComponent(message));
      const path=`/api/TempQuoteMessages?tempquoteid=${tempQuoteId}&userid=${userId}&message=${doubleEncodedMessage}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null, {responseType: 'text'}).pipe(
        map(response => {
          try {
            return {success: true, message: response}
          } catch (e) {
            return { success: false, message: response };
          }
        }),
        catchError((error: HttpErrorResponse) => {
          // You can return a structured error response as well
          return of({ success: false, message: error.error });
        })
      );
    }

    newUserMessageIndication(userId: string, indicationId: string, message: string){
        const doubleEncodedMessage = encodeURIComponent(encodeURIComponent(message));
      const path=`/api/TempQuoteMessages?indicationId=${indicationId}&userid=${userId}&message=${doubleEncodedMessage}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null, {responseType: 'text'}).pipe(
            map(response => {
              try {
                return {success: true, message: response}
              } catch (e) {
                return { success: false, message: response };
              }
            }),
            catchError((error: HttpErrorResponse) => {
              // You can return a structured error response as well
              return of({ success: false, message: error.error });
            })
        );
    }

    newUserMessageQuote(userId: string, quoteId: string, message: string){
        const doubleEncodedMessage = encodeURIComponent(encodeURIComponent(message));

      const path=`/api/TempQuoteMessages?quoteId=${quoteId}&userid=${userId}&message=${doubleEncodedMessage}`
      const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null, {responseType: 'text'}).pipe(
            map(response => {
              try {
                return {success: true, message: response}
              } catch (e) {
                return { success: false, message: response };
              }
            }),
            catchError((error: HttpErrorResponse) => {
              // You can return a structured error response as well
              return of({ success: false, message: error.error });
            })
        );
    }

    newUserMessagePolicy(userId: string, policyId: string, message: string){
        const doubleEncodedMessage = encodeURIComponent(encodeURIComponent(message));

      const path=`/api/TempQuoteMessages?userid=${userId}&message=${doubleEncodedMessage}&policyId=${policyId}`
      const encodedPath = encodeURIComponent(path);
      return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null, {responseType: 'text'}).pipe(
          map(response => {
            try {
              return {success: true, message: response}
            } catch (e) {
              return { success: false, message: response };
            }
          }),
          catchError((error: HttpErrorResponse) => {
            // You can return a structured error response as well
            return of({ success: false, message: error.error });
          })
    );
  }

    onUpdateSystemUserMessages(data: boolean){
      this.systemUserMessages$.next(data);
    }

    getSystemUserMessages() {
      return this.systemUserMessages$.asObservable();
    }

    resetSystemUserMessages(){
      this.systemUserMessages$.next(false) // reset to default value;
    }

    getCurrentDateTime() {
      const now = new Date();
  
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

}